import { FC, ReactNode } from 'react';
import { Badge } from './Badge';
import { DuoBadgeCheckIcon } from '../theme/Icons';
import { IonButton } from '@ionic/react';
import { IThemeColor } from '../theme/IThemeColor';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';

type INudgeBannerProps = {
    message: string | ReactNode;
    excludeIcon?: boolean;
    color?: IThemeColor;
    buttonLabel?: string;
    buttonClickHandler?: () => void;
    buttons?: {
        label: string;
        clickHandler: () => void;
        'data-type'?: string;
    }[],
    'data-type'?: string;
    allowAsViewer?: boolean;
};

export const NudgeBanner: FC<INudgeBannerProps> = ({
    message,
    excludeIcon = false,
    color = 'success',
    buttonLabel,
    buttonClickHandler = () => {},
    buttons,
    'data-type': dataType = 'edit-nudge-badge',
    allowAsViewer = false
}) => {
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);
    const isViewer = !careMapState.hasPermissionTo('put');
    if (isViewer && !allowAsViewer) {
        return null;
    }

    return (
        <div style={{margin: '20px 0'}} data-type={dataType}>
            <Badge color={color} size="small">
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {!excludeIcon && (
                        <div style={{padding: 12}}>
                            <DuoBadgeCheckIcon color={color} size="xlarge" />
                        </div>
                    )}
                    <div style={{flexGrow: 1, padding: 12}} data-type="message">{message}</div>
                </div>
                {buttonLabel && buttonClickHandler ? (
                    <div style={{padding: '10px 50px 10px 50px'}}>
                        <IonButton expand="block" onClick={buttonClickHandler}>{buttonLabel}</IonButton>
                    </div>
                ) : buttons && (
                    <div style={{padding: '10px 50px 10px 50px', display: 'flex', flexDirection: 'column', gap: 4}}>
                        {buttons.map((btn, idx) => (
                            <IonButton
                                key={`key-${idx}`}
                                expand="block"
                                onClick={btn.clickHandler}
                                data-type={btn['data-type']}
                            >{btn.label}</IonButton>
                        ))}
                    </div>
                )}
            </Badge>
        </div>
    );
};
